'use client';

import GTMEvent from "@lib/gtm_events/GTMEvent";
import Button from "./Button";
import Spacer from "../Spacer";

const OpenTableButton = () => {
    return (
        <>
            <Button
                text="MAKE A RESERVATION"
                href="https://www.opentable.com.au/restref/client/?restref=171431&lang=en-AU&ot_source=Restaurant%20website&corrid=7577b9b9-33eb-46a1-a370-2f693c136185"
                onClick={() => {
                    GTMEvent('reservation_click');
                }}
                target="_blank"
            />
            <Spacer type="medium"/>
            <Button
                text="ENQUIRE ABOUT PRIVATE DINING"
                href="https://www.opentable.com.au/private-dining/restaurant/171431"
                onClick={() => {
                    GTMEvent('private_dining_click');
                }}
                target="_blank"
            />
        </>
    );
};

export default OpenTableButton;
